import { useEffect, useId } from 'react';

import { Maybe } from '~/cms';

import styles from './VideoAltText.module.scss';

const VideoAltText = ({
  text,
  describes,
}: {
  text: Maybe<string>;
  describes?: Maybe<HTMLElement | undefined | null>;
}) => {
  const id = `videoAltText_${useId()}`;

  useEffect(() => {
    if (!describes) return;
    describes.setAttribute('aria-describedby', id);
  }, [describes, id]);

  if (!text) return null;

  return (
    <p id={id} className={styles.altText}>
      {text}
    </p>
  );
};

VideoAltText.displayName = 'VideoAltText';

export default VideoAltText;
